import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { sendBulkCommandService } from '../services/deviceCommands';
import {
    SEND_BULK_REQUEST,
    sendBulkSuccess,
    sendBulkFailure
} from '../actions/deviceCommands';
import { accessTokenSelector } from '../../auth/selectors/token';

const sendBulkWorker = function* ({ payload: { imeis, actionType } }) {
    try {
        const token = yield select(accessTokenSelector);

        const { data } = yield call(
            sendBulkCommandService,
            { imeis, action_type: actionType },
            token
        );

        yield put(sendBulkSuccess(data));
    } catch (err) {
        const message = err?.response?.data?.message
            || err?.message
            || 'Error al enviar los comandos';

        yield put(sendBulkFailure(Array.isArray(message) ? message.join(', ') : message));
    }
};

export default function* deviceCommandsSaga() {
    yield all([takeLatest(SEND_BULK_REQUEST, sendBulkWorker)]);
}
